
            <div class="flex flex-col justify-start items-start dark:bg-white bg-white py-2 w-full"  >
      <div class=" flex flex-col md:flex-row justify-start items-start md:items-center md:space-x-6 xl:space-x-8 w-full border-2 border-purple-700 rounded-lg"   >
                      <div class=" p-3 w-full md:w-40" (click)="getProductById(product.product_id?._id)">
                        <!-- <img 
    class="w-full hidden md:block" 
    [src]="mycartImageUrl + (variantImages || product?.product_id?.images[0])" 
    alt="dress" 
  />

  <img 
    class="w-full md:hidden" 
    [src]="mycartImageUrl + (variantImages || product?.product_id?.images[0])" 
    alt="dress" 
  /> -->

  <img
    class="w-full"
    [src]="
      variantImages
        ? productImageTemp + variantImages
        : mycartImageUrl + (product?.product_id?.thumbnail || product?.product_id?.images?.[0])
    "
    alt="product"
  />

      </div>
                      <div class=" md:flex-row flex-col flex justify-between items-start w-full pb-4 space-y-4 md:space-y-0 m-2" >
                          <div class="w-full flex flex-col justify-start items-start space-y-8">
                          
                              <div class="flex flex-col items-start space-y-3 lg:my-6">

  <!-- PRODUCT NAME -->
  <p class="text-purple-700 text-lg lg:text-xl font-semibold line-clamp-2">
    {{ product?.product_id?.productDetails?.productName }}
  </p>

  <!-- VARIANT INFO -->
  <div class=" flex-wrap items-center gap-x-6 gap-y-2 text-base text-black">

    <!-- COLOR -->
    <div class="flex items-center gap-2">
      <span class="font-medium text-gray-700">Color:</span>
      <span
  class="w-3 h-3 rounded-full border"
  [style.background]="selectedColor"
  *ngIf="selectedColor"
></span>

      <span class="capitalize">
        {{ selectedColor 
            ? (selectedColor | titlecase) 
            : (product?.product_id?.productDetails?.productColor | titlecase) }}
      </span>
    </div>

    <!-- SIZE -->
    <div
      class="flex items-center gap-2"
      *ngIf="attributeSize || variantData?.attributes?.size"
    >
      <span class="font-medium text-gray-700">Size:</span>
      <span>
        {{ attributeSize?.name || variantData?.attributes?.size || product?.size }}
      </span>
    </div>

  </div>

  <!-- PRICE -->
  <p class="text-black text-lg lg:text-xl font-bold">
    Rs. {{ displayPrice }}
  </p>

</div>

                          </div>
                          <div class="w-full flex flex-col justify-start items-start space-x-4 relative lg:top-7 sm:top-0">
                              <div class="flex justify-start border border-purple-700 rounded-lg">
                                  <!-- Decrease Quantity Button or Delete Button -->
                                  <button 
                                    class="border-r py-1 px-2 border-purple-700" 
                                    *ngIf="product?.quantity > 1" 
                                    (click)="removeQty(product?.product_id?._id, product?.quantity, product)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7" viewBox="0 0 24 24">
                                      <path fill="currentColor" d="M19 12.998H5v-2h14z"/>
                                    </svg>
                                  </button>
                                
                                  <!-- Delete Item if Quantity is 1 -->
                                  <button 
                                    class="border-r py-1 px-2 border-purple-700" 
                                    *ngIf="product?.quantity <= 1" 
                                    (click)="deleteCartItem(product?.product_id?._id, product?.quantity)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 16 16">
                                      <path fill="currentColor" fill-rule="evenodd" 
                                            d="M5.75 3V1.5h4.5V3zm-1.5 0V1a1 1 0 0 1 1-1h5.5a1 1 0 0 1 1 1v2h2.5a.75.75 0 0 1 0 1.5h-.365l-.743 9.653A2 2 0 0 1 11.148 16H4.852a2 2 0 0 1-1.994-1.847L2.115 4.5H1.75a.75.75 0 0 1 0-1.5zm-.63 1.5h8.76l-.734 9.538a.5.5 0 0 1-.498.462H4.852a.5.5 0 0 1-.498-.462z" clip-rule="evenodd"/>
                                    </svg>
                                  </button>
                                
                                  <!-- Product Quantity Display -->
                                  <span class="text-center font-semibold w-8 text-lg my-auto mx-auto">{{ product?.quantity }}</span>
                                
                                  <!-- Increase Quantity Button -->
                                  <button 
                                    class="border-l py-1 px-2 border-purple-700" 
                                    (click)="addQty(product?.product_id?._id, product?.quantity, product)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7" viewBox="0 0 24 24">
                                      <path fill="currentColor" d="M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z"/>
                                    </svg>
                                  </button>
                                </div>
                                
                          </div>
                          <div class="flex justify-between space-x-5 items-start w-full">
                              <div class="flex items-center lg:my-8  sm:mb-10 rounded-lg w-fit" >
                                  <!-- <p class=" dark:text-purple-700 leading-none text-purple-700 text-xl font-semibold" *ngIf="!variantData && !attributeSize">Rs.{{   product?.product_id?.priceInventoryShippingInfo?.sellingPrice * product?.quantity}}</p>
                                  <p class=" dark:text-purple-700 leading-none text-purple-700 text-xl font-semibold" *ngIf="variantData && !attributeSize && variantData.sellingPrice ">Rs.{{  variantData.sellingPrice  * product?.quantity}}</p>
                                  <p class=" dark:text-purple-700 leading-none text-purple-700 text-xl font-semibold" *ngIf="!variantData && attributeSize">Rs.{{  attributeSize.price  * product?.quantity}}</p>
                                  <p class=" dark:text-purple-700 leading-none text-purple-700 text-xl font-semibold" *ngIf="variantData && attributeSize">Rs.{{  attributeSize.price  * product?.quantity}}</p> -->
                                <p class="text-purple-700 text-xl font-semibold">
    Rs. {{ displayPrice * product?.quantity }}
  </p>

                              </div>  
                          </div>
                          <div class="flex justify-between space-x-5 items-start w-full">
                              <div class="flex items-center lg:my-6  rounded-lg w-fit">
                                  <button  (click)="deleteCartItem(product?.product_id?._id, product?.quantity)" type="button" class="btncolor shadow-md shadow-black font-semibold text-white p-4 rounded-full">
                                      <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M5.75 3V1.5h4.5V3zm-1.5 0V1a1 1 0 0 1 1-1h5.5a1 1 0 0 1 1 1v2h2.5a.75.75 0 0 1 0 1.5h-.365l-.743 9.653A2 2 0 0 1 11.148 16H4.852a2 2 0 0 1-1.994-1.847L2.115 4.5H1.75a.75.75 0 0 1 0-1.5zm-.63 1.5h8.76l-.734 9.538a.5.5 0 0 1-.498.462H4.852a.5.5 0 0 1-.498-.462z" clip-rule="evenodd"/></svg>
                                  </button>
                                  
                                  <button type="button" class="btncolor shadow-md shadow-black ml-4 font-semibold text-white p-4 rounded-full">
                                      <svg xmlns="http://www.w3.org/2000/svg" class="w-6 w-6" viewBox="0 0 48 48"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M15 8C8.925 8 4 12.925 4 19c0 11 13 21 20 23.326C31 40 44 30 44 19c0-6.075-4.925-11-11-11c-3.72 0-7.01 1.847-9 4.674A10.987 10.987 0 0 0 15 8"/></svg>  </button>
                              </div>  
                          </div>
                      </div>
                  </div>
              
              </div>

            
